// CAPSULE-REDESIGN 27/08/2026: saber se a ultima interaccao foi teclado
// ou ponteiro, para a gaveta decidir se deve deixar o anel de foco no
// icone do carrinho ao fechar. Capturado na fase de captura para nao
// depender de nenhum outro listener.
window.capsuleFocoPorTeclado = false;
document.addEventListener('keydown', function (e) {
  if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ') { window.capsuleFocoPorTeclado = true; }
}, true);
document.addEventListener('pointerdown', function () { window.capsuleFocoPorTeclado = false; }, true);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    // CAPSULE-REDESIGN 23/07/2026 (v12): pedido do Jorge — o carrinho
    // "sai do cabecalho", por isso o cabecalho tem de estar visivel
    // sempre que o carrinho abre, MAS sem mexer na posicao real da
    // pagina (a v11 fazia scrollTo(0,0), o que levava o fundo do
    // carrinho para o topo da pagina em vez de ficar no sitio onde o
    // utilizador estava, e so "voltava" ao reabrir a pagina la — nunca
    // era mesmo restaurado). O cabecalho deste tema ja tem o mecanismo
    // certo para isto nativo do Dawn: o custom element <sticky-header>
    // com o metodo reveal(), que so alterna classes CSS (mostra o
    // cabecalho sobreposto, sem tocar no scroll) — e o mesmo que o
    // assets/cart-notification.js nativo chama antes de abrir a
    // notificacao do carrinho. Aqui faz-se o mesmo antes de abrir a
    // gaveta.
    document.querySelector('sticky-header')?.reveal();

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');

    // cart-drawer-items is a CartItems subclass that extends createViewEventElement.
    // Its `view-event-trigger="manual"` skips auto-dispatch on connect; we fire
    // it here when the drawer opens, with `context: 'dialog'` from the payload attribute.
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    // CAPSULE-REDESIGN 27/08/2026: o Jorge viu um quadrado a volta do icone
    // do carrinho depois de fechar a gaveta, em mobile. Causa: o Dawn
    // devolve o foco ao icone (removeTrapFocus) e o Safari conta esse foco
    // programatico como foco de teclado, activando .focus-inset:focus-visible
    // do base.css (contorno de 0.2rem encostado ao icone).
    // So se tira o foco quando a ultima interaccao foi com dedo/rato; com
    // teclado o anel continua a aparecer, que e o que a acessibilidade quer.
    if (!window.capsuleFocoPorTeclado && this.activeElement && this.activeElement.blur) {
      this.activeElement.blur();
    }
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// CAPSULE-REDESIGN 23/07/2026 (v4): dropdown de quantidade "1 v", tal
// como no ecra de referencia da Apple, a substituir o selector +/-. So
// muda o valor do input real (escondido) e dispara "change" — quem
// valida/atualiza o carrinho continua a ser o assets/cart.js nativo,
// sem alteracoes. Definido como custom element para se auto-inicializar
// sempre que aparece no HTML, incluindo depois de cada troca AJAX do
// carrinho (o browser faz upgrade automatico de elementos personalizados
// inseridos via innerHTML, ao contrario de <script> inline).
class CapsuleQtyDropdown extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector('.capsule-bag__qty-toggle');
    this.list = this.querySelector('.capsule-bag__qty-list');
    this.input = this.querySelector('.capsule-bag__qty-hidden-input');
    this.valueLabel = this.querySelector('.capsule-bag__qty-value');
    this.changeEvent = new Event('change', { bubbles: true });

    if (!this.toggleButton || !this.list || !this.input) return;

    this.toggleButton.addEventListener('click', (event) => {
      event.stopPropagation();
      this.isOpen ? this.closeList() : this.openList();
    });

    this.list.addEventListener('click', (event) => {
      const option = event.target.closest('[role="option"]');
      if (!option) return;
      this.selectValue(option);
    });

    this._onDocumentClick = (event) => {
      if (!this.contains(event.target)) this.closeList();
    };
    document.addEventListener('click', this._onDocumentClick);

    // CAPSULE-REDESIGN 23/07/2026 (v6): se a Shopify recusar a
    // quantidade escolhida (ex: pediste 2, so ha 1 em stock), o
    // assets/cart.js nativo repoe sozinho this.input.value para o valor
    // valido, mas por ser uma alteracao direta da propriedade (nao do
    // atributo) nao dispara nenhum evento — sem isto o dropdown ficava
    // preso a mostrar o numero recusado. PUB_SUB_EVENTS.cartUpdate e
    // publicado sempre no fim de updateQuantity (sucesso OU erro), por
    // isso e o sitio certo para voltar a sincronizar com o valor real.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this._cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        this.syncFromInput();
      });
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onDocumentClick);
    if (this._cartUpdateUnsubscriber) this._cartUpdateUnsubscriber();
  }

  syncFromInput() {
    const current = this.input.value;
    if (this.valueLabel.textContent !== current) {
      this.valueLabel.textContent = current;
    }
    this.list.querySelectorAll('[role="option"]').forEach((opt) => {
      const selected = opt.dataset.value === current;
      opt.classList.toggle('is-selected', selected);
      opt.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
  }

  get isOpen() {
    return !this.list.hidden;
  }

  openList() {
    if (this.toggleButton.disabled) return;
    this.list.hidden = false;
    this.toggleButton.setAttribute('aria-expanded', 'true');
  }

  closeList() {
    this.list.hidden = true;
    this.toggleButton.setAttribute('aria-expanded', 'false');
  }

  selectValue(option) {
    const value = option.dataset.value;
    if (value !== this.input.value) {
      this.input.value = value;
      this.valueLabel.textContent = value;
      this.list.querySelectorAll('[role="option"]').forEach((opt) => {
        const selected = opt === option;
        opt.classList.toggle('is-selected', selected);
        opt.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      this.input.dispatchEvent(this.changeEvent);
    }
    this.closeList();
  }
}

customElements.define('capsule-qty-dropdown', CapsuleQtyDropdown);

// CAPSULE-REDESIGN 23/07/2026 (v6): estimativa de entrega no carrinho,
// mesma logica/formulas do tema live (snippets/estimated-delivery.liquid
// do tema "ella (ocultar camara+desconto 21-07)", pedido explicito do
// Jorge: "vai encontrar isso no codigo que esta em live e mete a mesma
// logica, o mesmo codigo"). Copiado tal e qual (feriados fixos e
// moveis via calculo da Pascoa, hora de corte 15h, contagem de dias
// uteis) — so a parte de UI e diferente (uma linha de texto no
// carrinho, em vez do cartao com o percurso Compra/Envio/Entrega da
// pagina de produto, que nao fazia sentido aqui). Depende da mesma
// biblioteca externa date.js, carregada no snippets/cart-drawer.liquid.
var CAPSULE_DELIVERY_DIAS = [
  'Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado',
];
var CAPSULE_DELIVERY_MESES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];
var CAPSULE_DELIVERY_CORTE_H = 15;
var CAPSULE_DELIVERY_FERIADOS_FIXOS = [
  '01-01', '04-25', '05-01', '06-10', '08-15', '10-05', '11-01', '12-01', '12-08', '12-25',
];

function capsuleDeliveryPascoa(ano) {
  var a = ano % 19,
    b = Math.floor(ano / 100),
    c = ano % 100,
    d = Math.floor(b / 4),
    e = b % 4,
    f = Math.floor((b + 8) / 25),
    g = Math.floor((b - f + 1) / 3),
    h = (19 * a + b - d - g + 15) % 30,
    i = Math.floor(c / 4),
    k = c % 4,
    l = (32 + 2 * e + 2 * i - h - k) % 7,
    m = Math.floor((a + 11 * h + 22 * l) / 451),
    mes = Math.floor((h + l - 7 * m + 114) / 31),
    dia = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(ano, mes - 1, dia);
}

function capsuleDeliveryFeriadosMoveis(ano) {
  var p = capsuleDeliveryPascoa(ano);
  return [p.toString('MM-dd'), p.clone().addDays(-2).toString('MM-dd'), p.clone().addDays(60).toString('MM-dd')];
}

function capsuleDeliveryIsFeriado(d, feriados) {
  return feriados.includes(d.toString('MM-dd'));
}

function capsuleDeliveryProximoUtil(d, feriados) {
  while (d.getDay() === 0 || d.getDay() === 6 || capsuleDeliveryIsFeriado(d, feriados)) d = d.addDays(1);
  return d;
}

function capsuleDeliveryBaseEnvio(now, feriados) {
  var corte = new Date(now.getFullYear(), now.getMonth(), now.getDate(), CAPSULE_DELIVERY_CORTE_H, 0, 0);
  var base = now < corte ? now.clone() : now.clone().addDays(1);
  return capsuleDeliveryProximoUtil(base, feriados);
}

function capsuleDeliverySomarUteis(d, n, feriados) {
  var x = d.clone();
  for (var i = 0; i < n; i++) x = capsuleDeliveryProximoUtil(x.addDays(1), feriados);
  return x;
}

// CAPSULE-REDESIGN 23/07/2026 (v8): formato pedido pelo Jorge —
// "Amanhã 23 Julho - Segunda 27 Julho - Portes Grátis", sem virgulas,
// mes por extenso, nomes em maiuscula inicial.
function capsuleDeliveryFormatCompleta(d) {
  return CAPSULE_DELIVERY_DIAS[d.getDay()] + ' ' + d.getDate() + ' ' + CAPSULE_DELIVERY_MESES[d.getMonth()];
}

function capsuleDeliveryEAmanhaUtil(agora, entrega, feriados) {
  var amanha = agora.clone().addDays(1);
  var amanhaEhUtil = amanha.getDay() !== 0 && amanha.getDay() !== 6 && !capsuleDeliveryIsFeriado(amanha, feriados);
  return entrega.toString('yyyy-MM-dd') === amanha.toString('yyyy-MM-dd') && amanhaEhUtil;
}

// CAPSULE-REDESIGN 23/07/2026 (v8): intervalo de 24h-48h, formato
// "Amanhã 23 Julho - Segunda 27 Julho - Portes Grátis". Mesma
// logica/formulas de dias uteis e feriados de sempre (nada mudou nesse
// calculo) — calcula DOIS pontos com capsuleDeliverySomarUteis (envio+1
// e envio+2 dias uteis).
// Devolve o texto pronto a mostrar, ou null se a date.js ainda nao
// carregou (raro, so na fracao de segundo inicial).
// CAPSULE-REDESIGN 24/07/2026 (v25): logica do intervalo extraida para
// capsuleDeliveryRangeText() (so "Amanha 24 Julho — Segunda 27 Julho",
// sem sufixo) para poder ser reaproveitada tambem na pagina de produto
// (texto final diferente do carrinho), a pedido do Jorge.
function capsuleDeliveryRangeText() {
  if (typeof Date.prototype.clone !== 'function') return null;

  var agora = new Date();
  var ano = agora.getFullYear();
  var feriados = CAPSULE_DELIVERY_FERIADOS_FIXOS.concat(capsuleDeliveryFeriadosMoveis(ano));

  var envio = capsuleDeliveryBaseEnvio(agora.clone(), feriados);
  var entregaMin = capsuleDeliverySomarUteis(envio.clone(), 1, feriados);
  var entregaMax = capsuleDeliverySomarUteis(envio.clone(), 2, feriados);
  var corteHoje = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate(), CAPSULE_DELIVERY_CORTE_H, 0, 0);

  var minText;

  if (agora < corteHoje && capsuleDeliveryEAmanhaUtil(agora, entregaMin, feriados)) {
    minText = 'Amanhã ' + entregaMin.getDate() + ' ' + CAPSULE_DELIVERY_MESES[entregaMin.getMonth()];
  } else {
    minText = capsuleDeliveryFormatCompleta(entregaMin);
  }

  var maxText = capsuleDeliveryFormatCompleta(entregaMax);

  return minText + ' — ' + maxText;
}

// CAPSULE-REDESIGN 27/08/2026: o sufixo " - Grátis" so entra quando o
// total do carrinho chega aos 50 EUR, que e' a condicao real do envio
// gratuito no Shopify (zona Portugal, CTT Expresso 48H a 0 EUR com
// TOTAL_PRICE >= 50). Antes dizia sempre Gratis, mesmo num carrinho de
// 9,90, o que contradizia a linha "Envio" dos totais mesmo ao lado.
function capsuleDeliveryComputeText(totalCents) {
  var range = capsuleDeliveryRangeText();
  if (!range) return null;
  return totalCents >= 5000 ? range + ' - Grátis' : range;
}

class CapsuleDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    this.renderText();
  }

  renderText() {
    var textEl = this.querySelector('.capsule-bag__item-delivery-text');
    if (!textEl) return;
    var totalCents = parseInt(this.getAttribute('data-cart-total'), 10);
    var text = capsuleDeliveryComputeText(isNaN(totalCents) ? 0 : totalCents);
    if (text) {
      textEl.textContent = text;
    } else {
      setTimeout(this.renderText.bind(this), 150);
    }
  }
}

customElements.define('capsule-delivery-estimate', CapsuleDeliveryEstimate);
